export const setStorageExpire = (key, value, expire = 60 * 24 * 30) => {
  const obj = {
    data: value,
    time: Date.now(),
    expire: 1000 * 60 * expire, // 单位是分钟
  };
  localStorage.setItem(key, JSON.stringify(obj));
};

/**
 * 判断key是否过期
 * @param key 键
 */
export const getStorageExpire = (key) => {
  const val = localStorage.getItem(key);
  if (val != null) {
    const storageInfo = JSON.parse(val);
    const timeSpan = Date.now() - storageInfo.time;

    if (timeSpan > storageInfo.expire) {
      localStorage.removeItem(key);
      return null;
    }

    return storageInfo.data;
  }
  return null;
};

export const isPhone = () => {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
};

export const isWeiXin = () => {
  var a = navigator.userAgent.toLowerCase();
  if (a.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
};
export const transformUrl = (str) => {
  if (!str) return {};
  // 创建目标对象
  var $_REQUEST = new Object(),
    // 截取数据字符串
    data = str.slice(str.indexOf("?"), str.length),
    // 将数据字符串表现为数组
    aParams = data.substr(1).split("&");
  //console.log(data);
  //console.log(aParams);
  for (let i = 0; i < aParams.length; i++) {
    // 数据属性与数值分离
    var aParam = aParams[i].split("=");
    // 使用属性括号进行属性赋值
    $_REQUEST[aParam[0]] = aParam[1];
  }
  return $_REQUEST;
};

// func是用户传入需要防抖的函数
// wait是等待时间
export const debounce = (func, wait = 50) => {
  // 缓存一个定时器id
  let timer = 0;
  // 这里返回的函数是每次用户实际调用的防抖函数
  // 如果已经设定过定时器了就清空上一次的定时器
  // 开始一个新的定时器，延迟执行用户传入的方法
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
};

// func是用户传入需要节流的函数
// wait是等待时间
export const throttle = (func, wait = 50) => {
  // 上一次执行该函数的时间
  let lastTime = 0;
  return function (...args) {
    // 当前时间
    let now = +new Date();
    // 将当前时间和上一次执行函数时间对比
    // 如果差值大于设置的等待时间就执行函数
    if (now - lastTime > wait) {
      lastTime = now;
      func.apply(this, args);
    }
  };
};

export const deepClone = (obj) => {
  function isObject(o) {
    return (typeof o === "object" || typeof o === "function") && o !== null;
  }

  if (!isObject(obj)) {
    throw new Error("非对象");
  }

  let isArray = Array.isArray(obj);
  let newObj = isArray ? [...obj] : { ...obj };
  Reflect.ownKeys(newObj).forEach((key) => {
    newObj[key] = isObject(obj[key]) ? deepClone(obj[key]) : obj[key];
  });

  return newObj;
};

export const formatDate = (timestamp) => {
  if (!timestamp) {
    return;
  }
  const date = new Date(timestamp);
  const Y = date.getFullYear() + '-';
  const M = ('0' + (date.getMonth() + 1)).slice(-2) + '-';
  const D = ('0' + date.getDate()).slice(-2);
  return Y + M + D;
}

export const generateRandomString = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 10; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
  }
  return result;
}
// 导出文件名
export function getFileNameFromDisposition(contentDisposition) {
  if (!contentDisposition) return 'download.xlsx';
  // 处理 `filename*=utf-8''...`
  const filenameRegex = /filename\*=(?:UTF-8''|utf-8'')?([^;]*)/i;
  const match = contentDisposition.match(filenameRegex);
  if (match && match[1]) {
    return decodeURIComponent(match[1]); // 解码文件名
  }
  // 备用处理 `filename="xxx.xlsx"`
  const fallbackRegex = /filename="(.+?)"/;
  const fallbackMatch = contentDisposition.match(fallbackRegex);
  if (fallbackMatch && fallbackMatch[1]) {
    return fallbackMatch[1];
  }
  // 尝试简单提取文件名（假设文件名在最后）
  const parts = contentDisposition.split(';');
  for (let i = parts.length - 1; i >= 0; i--) {
    const part = parts[i].trim();
    if (part.startsWith('filename=')) {
      const fileName = part.slice('filename='.length).trim();
      if (fileName.startsWith('"') && fileName.endsWith('"')) {
        return fileName.slice(1, -1);
      }
      return decodeURIComponent(fileName);
    }
  }
  return 'download.xlsx';
}


